export const bItemData = [
  {
    imgSrc:"./images/main/best/item_01.jpg",
    cateName:"런스타",
    itemName:"런스타 하이크 OX 블랙",
    itemPrice:"109,000"
  },
  {
    imgSrc:"./images/main/best/item_02.jpg",
    cateName:"척70",
    itemName:"척70 레더 블랙",
    itemPrice:"115,000"
  },
  {
    imgSrc:"./images/main/best/item_03.jpg",
    cateName:"척테일러",
    itemName:"척테일러 올스타 무브 플랫폼 셰르파 비치 스톤",
    itemPrice:"65,000"
  },
  {
    imgSrc:"./images/main/best/item_04.jpg",
    cateName:"런스타",
    itemName:"런스타 레거시 첼시 cx 블랙",
    itemPrice:"129,000"
  },
  {
    imgSrc:"./images/main/best/item_05.jpg",
    cateName:"척70",
    itemName:"척70 시즈널 컬러 언차티드 워터스",
    itemPrice:"95,000"
  },
  {
    imgSrc:"./images/main/best/item_06.jpg",
    cateName:"척70",
    itemName:"척70 시즈널 컬러 써니 오아시스",
    itemPrice:"95,000"
  },
  {
    imgSrc:"./images/main/best/item_07.jpg",
    cateName:"척테일러",
    itemName:"척테일러 올스타 무브 블랙",
    itemPrice:"85,000"
  },
  {
    imgSrc:"./images/main/best/item_08.jpg",
    cateName:"척테일러",
    itemName:"척테일러 올스타 리프트 캔버스 블랙",
    itemPrice:"85,000"
  },
  {
    imgSrc:"./images/main/best/item_09.jpg",
    cateName:"척테일러",
    itemName:"척테일러 올스타 리프트 캔버스 화이트",
    itemPrice:"79,000"
  },
  {
    imgSrc:"./images/main/best/item_10.jpg",
    cateName:"척테일러",
    itemName:"척테일러 올스타 클래식 화이트",
    itemPrice:"59,000"
  },
];